import React from 'react';
const { useNavigate } = require("react-router-dom");
const { useLazyGetFileUrlQuery } = require("store/services/utility");
import styles from './tableLayoutV2.module.scss'
import downArrow from 'Assets/images/downArrowPurple.png'
import upArrow from 'Assets/images/upArrowPurple.png'
import downArrowNormal from 'Assets/images/downArro.png'



const TableLayoutDetailsV2 = ({ openRow, toggleRow, expandableRowComponent, column, data, url, showHeader = true, noDataMsg = "Data not found", state, filter, handleRowClick, height, handleSort }) => {
    const navigate = useNavigate();
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    // const { data: consentFormList, error, isLoading: consentFormListLoading } = useGetConsentformListQuery({ client_id: clientId });

    const handleSortClick = (item) => {

        let sort = {};
        console.log('filter sort and item?.accessor', filter, item?.accessor)
        if (filter?.sort?.column == item?.accessor) {

            if (filter?.sort?.direction == "asc") sort = { column: item?.accessor, direction: "desc" };
            else sort = { column: "id", direction: "desc" };

        } else sort = { column: item?.accessor, direction: "asc" }

        typeof handleSort === "function" && handleSort(sort);
    };

    const handleViewPdf = async (name) => {

        try {
            const result = await getFileUrl(name);
            if (result?.error) return;

            const url = result?.data
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };



    return (
        <div className="favorite-goal-wrapper classroom-consultation proxima table_height" style={{ height: height || "calc(100vh - 220px)" }}>
            {
                getFileFetching && <LoadingOverlay />
            }
            <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
                <table className={` table`}>
                    {showHeader && (
                        <thead>
                            <tr className="">
                                {column &&
                                    column.length > 0 &&
                                    column.map((item, key) => (
                                        <>
                                            <th className="fw-medium" style={{ width: "10%", padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                <div className={`d-flex ${filter?.sort?.column == item?.accessor && "themePurple"}`}>
                                                    {item.head}
                                                    {
                                                        item?.sorter && <div className="px-2 cursor-pointer d-flex flex-column justify-content-center" onClick={() => handleSortClick(item)}>
                                                            {filter?.sort?.column == item?.accessor && filter?.sort?.direction?.toLowerCase() == "asc" && <img width={9} height={9} className="ms-2" src={upArrow} alt="downArrow" />}
                                                            {filter?.sort?.column == item?.accessor && filter?.sort?.direction?.toLowerCase() == "desc" && <img width={9} height={9} className="ms-2" src={downArrow} alt="downArrow" />}
                                                            {filter?.sort?.column != item?.accessor && <img width={9} height={6} className="ms-2" src={downArrowNormal} alt="downArrow" />}
                                                        </div>
                                                    }
                                                </div>
                                            </th >
                                        </>
                                    ))}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((row, idx) => (
                                <React.Fragment key={row.id || idx}>
                                    {/* Main Row */}
                                    <tr
                                        className={`${url ? "cursor-pointer" : ""}`}
                                        onClick={(e) => {
                                            if (row?.pdfList?.[0]?.attachment_key)
                                                handleViewPdf(row?.pdfList?.[0]?.attachment_key);
                                            else {
                                                url && navigate(`${url}/${row.id}`, { state });
                                                handleRowClick?.(row);
                                            }
                                        }}
                                    >
                                        {column?.map((item, key) => (
                                            <td key={key} style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                {item.component
                                                    ? item.component(row, idx, row)
                                                    : row[item?.accessor] || "--"}
                                            </td>
                                        ))}
                                    </tr>

                                    {/* Expanded Row */}
                                    {expandableRowComponent && openRow === row.id && (
                                        <tr style={{ position: 'relative', top: "-10px" }}>
                                            <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={2}></td>
                                            <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={7}>
                                                {expandableRowComponent(row)}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={column?.length || 1} className="text-center">
                                    {noDataMsg}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div >
    );
};

export default TableLayoutDetailsV2